import React from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip
} from "chart.js";

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip);

export default function DeductionChart() {

  const data = {
    labels: ["1","2","3","4","5","6","7"],

    datasets: [
      {
        label: "Deduction",

        // wave style heights like the image
        data: [12, 34, 26, 31, 36, 30, 28],

        backgroundColor: "#ff6b2c",
        borderRadius: 50,
        borderSkipped: false,

        barThickness: 8,
        categoryPercentage: 0.5,
        barPercentage: 0.6
      }
    ]
  };

  const options = {

    responsive: true,
    maintainAspectRatio: false,

    plugins: {

      legend: { display: false },

      tooltip: {
        backgroundColor: "#ffffff",
        titleColor: "#333",
        bodyColor: "#333",
        borderColor: "#e5e7eb",
        borderWidth: 1,
        padding: 10,
        displayColors: true,
        callbacks:{
          label:function(context){
            return ` Deduction: ${context.raw}`;
          }
        }
      }

    },

    scales: {

      x: {
        grid: { display:false },
        ticks: { display:false },
        border: { display:false }
      },

      y: {
        grid: { display:false },
        ticks: { display:false },
        border: { display:false }
      }

    }

  };

  return (
    <div style={{ width: "110px", height: "80px" }}>
      <Bar data={data} options={options} />
    </div>
  );
}